module.exports = __webpack_public_path__ + "static/media/suv_navy.a24840fa.svg";